import type { IPlaybackTimerStuckStatus } from '@/helpers/detectPlaybackTimerStuck'
import * as Sentry from '@sentry/vue'

export const PLAYBACK_TIMER_STUCK_SENTRY_ISSUE_COOLDOWN_MS = 15 * 60 * 1000

let lastReportedSuspected = false
let lastIssueCapturedAtMs = 0

/**
 * One breadcrumb per stuck episode, plus a cooldown-limited issue for operational alerting.
 */
export function reportPlaybackTimerStuckToSentry(status: IPlaybackTimerStuckStatus): void {
  if (!status.suspected) {
    lastReportedSuspected = false
    return
  }
  if (lastReportedSuspected) {
    return
  }
  lastReportedSuspected = true
  const data = {
    frameId: status.frameId,
    overrunMs: status.overrunMs,
    visibleDwellMs: status.visibleDwellMs,
    timingFlatlineMs: status.timingFlatlineMs
  }

  try {
    Sentry.addBreadcrumb({
      category: 'playback_timer_stuck',
      message: 'playback_timer_stuck_suspected',
      level: 'warning',
      data
    })
  }
  catch {
    /* Sentry not initialized or unavailable */
  }

  const nowMs = Date.now()
  if (
    lastIssueCapturedAtMs > 0
    && nowMs - lastIssueCapturedAtMs < PLAYBACK_TIMER_STUCK_SENTRY_ISSUE_COOLDOWN_MS
  ) {
    return
  }
  lastIssueCapturedAtMs = nowMs
  try {
    Sentry.captureMessage('Player playback timer stuck', {
      level: 'error',
      fingerprint: ['player-playback-timer-stuck'],
      tags: {
        playback_timer_stuck: 'true',
        player_diagnostics_fault: 'playback_timer_stuck'
      },
      extra: data
    })
  }
  catch {
    /* Sentry not initialized or unavailable */
  }
}

/** Test-only reset of dedupe state. */
export function resetPlaybackTimerStuckSentryDedupeForTests(): void {
  lastReportedSuspected = false
  lastIssueCapturedAtMs = 0
}
